module.exports = __webpack_public_path__ + "img/collapse.793e8675.svg";